<template>
  <div class="col-12 pl-2 pr-2 mb-2">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <div class="card bg-light" v-for="camera in cameras">
      <div class="card-header text-white pointer" @click="toggleCameraTabExpand(camera.name)">
        <h5 class="card-title mb-1 mt-1">
          {{ camera.name }}
        </h5>
      </div>

      <div class="card-body" v-if="expanded.indexOf(camera.name) !== -1">
        <div class="row">
          <div class="col-6" v-for="(preset, index) in camera.presets">
            <div class="card">
              <div class="card-body" :class="{'bg-ng rounded text-white pointer': hovered === preset.name}" @mouseenter="hovered = preset.name" @mouseleave="hovered = ''">
                <strong>{{ preset.name }}</strong><br>
                <img :src="preset.image" :alt="preset.name" class="img-fluid" style="height: 200px" @dblclick="applyPreset(camera.name, index)">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import { RepositoryFactory } from '../../../../../../../repositories/RepositoryFactory';

const DeviceControlRepository = RepositoryFactory.get('devicecontrol');

export default {
  name: 'CameraDeviceTab',
  components: { Loading, DeviceControlRepository },
  data() {
    return {
      expanded: [],
      hovered: '',
      isLoading: false,
    };
  },
  computed: {
    cameras() {
      	if (this.$store.state.deviceControlList === null) {
      		return null;
      }

      return this.$store.state.deviceControlList.filter(device => device.type === 'camera');
    },
  },
  methods: {
    async applyPreset(cameraName, presetName) {
      this.isLoading = true;
      await DeviceControlRepository.apply(cameraName, presetName)
        .then((response) => {
          this.isLoading = false;
          this.$snotify.info(this.$t('UI_DEVICE_COMTROL_CAMERA_PRESET_APPLIED'));
        });
    },

    toggleCameraTabExpand(cameraName) {
      const index = this.expanded.indexOf(cameraName);
      if (index !== -1) {
        this.expanded.splice(index, 1);
      } else {
        this.expanded.push(cameraName);
      }
    },
  },
};
</script>

<style scoped>

</style>
